module.exports = __webpack_public_path__ + "assets/img/39@3x.b9788b65.png";